import React from 'react';

// styled core
import styled from 'styled-components/macro';

// locales
import { useTranslation } from 'react-i18next';
import { translations } from 'locales/i18n';

import { ReactComponent as Star } from '../../assets/icons/star.svg';

interface IProps {
  active: boolean | undefined;
  click: () => void;
  colorType: SaveToggleStyles;
}

interface IStyledProps {
  active?: boolean;
  colorType?: SaveToggleStyles;
}

export enum SaveToggleStyles {
  Light = 'light',
  Default = 'default',
}

const StarIcon = styled(Star)<IStyledProps>`
  fill: ${props => props.colorType === SaveToggleStyles.Light && 'white'};
`;

const Wrapper = styled.button<IStyledProps>`
  display: flex;
  height: 100%;
  align-items: center;
  font-weight: 300;
  font-size: 14px;
  line-height: 16px;
  white-space: nowrap;
  border: none;
  background: transparent;
  outline: none;
  cursor: pointer;
  color: ${props =>
    props.active
      ? props.theme.colors.primary
      : props.colorType === SaveToggleStyles.Light
      ? 'white'
      : props.theme.colors.black};

  svg {
    margin-right: 10px;
    fill: ${props => props.colorType === SaveToggleStyles.Light && 'white'};

    .border {
      fill: ${props => props.colorType === SaveToggleStyles.Light && 'white'};
    }

    .border,
    .inner {
      fill: ${props => props.active && props.theme.colors.primary};
    }
  }

  &:hover {
    color: ${props => props.theme.colors.primary};

    svg {
      .border {
        fill: ${props => props.theme.colors.primary};
      }
    }
  }
`;

export const SaveButton = ({ active, click, colorType }: IProps) => {
  // locales hook
  const { t } = useTranslation();

  return (
    <Wrapper active={active} colorType={colorType} onClick={click}>
      <StarIcon />
      {active ? t(translations.global.saved) : t(translations.global.save)}
    </Wrapper>
  );
};

export default SaveButton;
